import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function CategoryGrid() {
  const navigate = useNavigate();
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            题材分类<span className="text-primary-500">速览</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按题材快速定位，国漫、日漫都在里面</p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/guoman')}
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          全部作品 <i className="ri-arrow-right-line"></i>
        </button>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {categories.map((c) => (
          <button
            key={c.slug}
            type="button"
            onClick={() => navigate(`/guoman?q=${encodeURIComponent(c.name)}`)}
            className="group flex items-center gap-3 rounded-xl border border-background-200 bg-background-100 p-4 text-left transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:shadow-soft"
          >
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-lg ${toneMap[c.tone]}`}>
              <i className={c.icon} aria-hidden="true"></i>
            </span>
            <span>
              <span className="block font-medium text-foreground-900">{c.name}</span>
              <span className="block text-xs text-foreground-500">{c.count} 部作品</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}